import React from 'react'
import { pushDataLayerEvent } from '../../../utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../utils/userInfo'
import './input-points.scss'

const InputPoints = ({
	totalInputs,
	inputRef,
	isVisible,
	isValid,
	errorMsg,
	removeKey,
	indexForm,
	isMobile,
	isAccount,
	clickAction,
}) => {
	const elementsRef = React.useRef(
		Array(totalInputs)
			.fill(0)
			.map(() => React.createRef())
	)
	const handleInputKeyUp = (_index, _evt) => {
		if (_evt.keyCode === 46 || _evt.keyCode === 8) {
			if (_index < elementsRef.current.length - 1 && _index !== 0) {
				elementsRef.current[_index - 1].current.focus()
			} else {
				elementsRef.current[_index].current.blur()
			}
		} else {
			if (elementsRef.current[_index].current.value.length === 1) {
				if (_index < elementsRef.current.length - 1) {
					elementsRef.current[_index + 1].current.focus()
				} else {
					elementsRef.current[_index].current.blur()
				}
			}
		}
	}
	const userInfo=dataLayerUserInfo()
	const dataLaterEliminar = () => {		
		let location=''
		if (typeof window !== 'undefined') {
			location= window.location.href
		}
		pushDataLayerEvent({event: 'Interacciones - Beneficios',
		category: 'acumula puntos',
		action: 'click',
		label:'Eliminar',
		location: location,
		user_data: userInfo.user_data? userInfo.user_data: '',
		log_status: userInfo.log_status,})
	}
	return (
		<>
			<form
				onClick={clickAction}
				className={`f-point-keys ${!isValid ? 'f-point-keys--error' : ''} ${
					isVisible ? 'f-point-keys--active' : ''
				} ${isAccount && 'account'}`}
				ref={inputRef}
			>
				{Array(totalInputs)
					.fill(0)
					.map((number, index) => (
						<input
							key={index}
							className='f-input'
							ref={elementsRef.current[index]}
							onKeyUp={evt => {
								handleInputKeyUp(index, evt)
							}}
							maxLength='1'
						/>
					))}
				{indexForm >= 1 ? (
					!isMobile && (
						<button onClick={removeKey} onClickCapture={dataLaterEliminar} className='f-remove-key'>
							Eliminar
						</button>
					)
				) : (
					<></>
				)}
			</form>

			{!isValid ? <label className='f-point-error'>{errorMsg}</label> : <></>}
			{indexForm >= 1 ? (
				isMobile && (
					<button
						onClick={removeKey}
						className={`f-remove-key-bottom ${
							isVisible ? 'f-remove-key-bottom--active' : ''
						}`}
					>
						Eliminar
					</button>
				)
			) : (
				<></>
			)}
		</>
	)
}
export default InputPoints
